import { PropsWithChildren, ReactNode } from 'react';
import {
  StyledDescription,
  StyledIconWrapper,
  StyledItemContent,
  StyledItemWrapper,
  StyledTextContentWrapper,
} from './styles';

export interface InfoWidgetItemLayoutProps extends PropsWithChildren {
  icon: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  closeIcon?: ReactNode;
}

export default function InfoWidgetItemLayout(props: InfoWidgetItemLayoutProps) {
  const { icon, title, description, children, closeIcon } = props;

  return (
    <div className="informa-payment-info-box-item">
      <StyledItemWrapper>
        <StyledIconWrapper>{icon}</StyledIconWrapper>
        <StyledTextContentWrapper>
          <div>
            <div className="informa-payment-info-box-item__title">{title}</div>
            {description && (
              <StyledDescription className="informa-payment-info-box-item__description">
                {description}
              </StyledDescription>
            )}
          </div>
          {closeIcon}
        </StyledTextContentWrapper>
      </StyledItemWrapper>
      {children && (
        <StyledItemContent className="informa-payment-info-box-item__content">
          {children}
        </StyledItemContent>
      )}
    </div>
  );
}
